(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('fidoTransactionCtrl', ['$scope', '$sce', '$http', 'uteEndpoint', '$rootScope', '$stateParams', '$state', 'transactionHistoryService', 'prepaidUserInfoService', 'httpService', 'uteLocale', function ($scope, $sce, $http, uteEndpoint, $rootScope, $stateParams, $state, transactionHistoryService, prepaidUserInfoService, httpService, uteLocale) {

      $scope.lang = uteLocale.language;
      $scope.callSelected = 'allTransactions';
      $scope.noRecordFoundFidoTransaction = false;
      var typeList = [];
      if ($scope.lang == 'en') {
        if (!(_.isEmpty(transactionHistoryService.getResponse().en.transactionHistory))) {
          $scope.noRecordFoundFidoTransaction = false;
          $scope.transactionResponse = transactionHistoryService.getResponse().en.transactionHistory;
        } else {
          $scope.noRecordFoundFidoTransaction = true;
        }
      } else {
        if (!(_.isEmpty(transactionHistoryService.getResponse().fr.transactionHistory))) {
          $scope.noRecordFoundFidoTransaction = false;
          $scope.transactionResponse = transactionHistoryService.getResponse().fr.transactionHistory;
        } else {
          $scope.noRecordFoundFidoTransaction = true;
        }
      }
      if (!($scope.noRecordFoundFidoTransaction)) {
        $.each($scope.transactionResponse, function (key, value) {
          var date = new Date(value.date);
          value.date = date;
        })
      }
      $scope.transOptions = typeList;
    }]);

})();
